module.exports = __webpack_public_path__ + "fonts/untitled-font-1.dc484ca.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/untitled-font-1.eot
// module id = ./src/assets/fonts/untitled-font-1.eot
// module chunks = 34